import React, { useState } from 'react';
import Modal from 'react-modal';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import classNames from 'classnames';
import { FaCog } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import DetailedSpaceInfo from '@/components/reusable/DetailedSpaceInfo';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import './NewSpaceCardShortVersion.scss';

Modal.setAppElement('#root');

const truncateDescription = (description, limit) => {
  if (description?.length > limit) {
    return description.substring(0, limit) + '...';
  }
  return description;
};

const NewSpaceCardShortVersion = props => {
  const {
    spaceInfo,
    isMobileStyle,
    handleDetailButton,
    isInlineStyle,
    isWhiteBg,
    priceAndCapacityDetails,
  } = props;

  const lenguage = useSelector(state => state.lenguage?.lang);
  const user = useSelector(state => state.user);

  const translations = {
    'Sala de Juntas': 'Meeting Room',
    Terrazas: 'Terrace',
    Coworking: 'Coworking Pass',
  };

  const translatedTitle =
    translations[spaceInfo?.subtype_title] || spaceInfo?.subtype_title;

  const containerClass = classNames(
    'spaceCardShortVersion borderGray050 border-rad8px bgWhite',
    {
      'gap-20 m-flex-column': isInlineStyle,
      'flex-column format100': !isInlineStyle,
      margtb20: isMobileStyle,
      bgWhite: isWhiteBg,
    },
  );

  const textContainerClass = classNames('flex-column padlr20', {
    'justify-around': isInlineStyle,
  });

  const mobileImageItemStyle = {
    width: '100%',
    height: '300px',
    objectFit: 'cover',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
  };

  const imagesArray = (() => {
    try {
      const parsed =
        spaceInfo?.url_img && spaceInfo?.url_img !== null
          ? JSON.parse(spaceInfo?.url_img)
          : JSON.parse(spaceInfo?.main_image);
      return Array.isArray(parsed) && parsed.length > 0
        ? parsed
        : [spaceInfo?.main_image].filter(Boolean);
    } catch {
      return [spaceInfo?.main_image].filter(Boolean);
    }
  })();

  const typeSpanStyle = { zIndex: 2 };
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const customModalStyles = {
    overlay: {
      position: 'fixed',
      zIndex: 1000,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      padding: '20px',
    },
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const prefix = spaceInfo?.subtype_title === 'Coworking' ? 'Day Pass: ' : '';

  return (
    <FlexContainer
      className={containerClass}
      onClick={handleDetailButton}
      style={{ position: 'relative' }}
    >
      {/* {user && (
        <div
          className="icon-container"
          onClick={e => {
            e.stopPropagation();
            console.log('Icon clicked', spaceInfo);
            openModal();
          }}
        >
          <FaCog size={24} color="#808080" />
        </div>
      )} */}

      {spaceInfo?.subtype_title && (
        <span
          style={typeSpanStyle}
          className="bgWhite border-rad4px text-14 padt12 padb12 padlr10 pos-abs margt20 marglr10"
        >
          {lenguage === 'EN' ? translatedTitle : spaceInfo?.subtype_title}
        </span>
      )}
      <FlexContainer className="width100 d-hide">
        <Swiper
          loop={true}
          autoplay={{
            delay: 10500,
            disableOnInteraction: true,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
        >
          {imagesArray?.map((image, index) => (
            <SwiperSlide key={index}>
              <img
                src={image}
                alt={spaceInfo?.space_name}
                style={{
                  ...mobileImageItemStyle,
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </FlexContainer>
      <FlexContainer className="width100 m-hide t-hide">
        <img
          src={imagesArray[0]}
          alt={spaceInfo?.space_name}
          style={{
            ...mobileImageItemStyle,
          }}
        />
      </FlexContainer>
      <FlexContainer className={textContainerClass}>
        <Label className="margt20 text-20 align-self-start">
          <strong>
            <div
              style={{ fontWeight: 500 }}
              dangerouslySetInnerHTML={{
                __html: truncateDescription(
                  prefix + spaceInfo?.relationship_title,
                  40,
                ),
              }}
            />
          </strong>
        </Label>
        <Label type="text-14 align-self-start">
          {truncateDescription(spaceInfo?.space_address, 30)}
        </Label>
        <Label type="text-14 align-self-start">
          {lenguage === 'ES' ? 'Capacidad Max:' : 'Max Capacity:'}{' '}
          {spaceInfo?.host_capacity}{' '}
          {lenguage === 'ES' ? ' Personas' : ' People'}
        </Label>
        {priceAndCapacityDetails && (
          <FlexContainer className="borderTp margt30 margb10 padt20 width100">
            <FlexContainer className="width100 flex-column gap-6">
              <FlexContainer className="width100">
                <Label className="fontGray6" type="text-12">
                  {spaceInfo?.host_capacity}{' '}
                  {lenguage === 'ES' ? ' Personas' : ' People'}
                </Label>
              </FlexContainer>
              <FlexContainer className="width100">
                {lenguage === 'ES' ? (
                  <Label className="fontGray6" type="text-12">
                    {spaceInfo?.subtype_title === 'Coworking'
                      ? 'Pase de Coworking'
                      : 'Precio por 1 h'}
                    .
                  </Label>
                ) : (
                  <Label className="fontGray6" type="text-12">
                    {spaceInfo?.subtype_title === 'Coworking'
                      ? 'Daily  Rate:'
                      : 'Price per 1 h:'}
                  </Label>
                )}
              </FlexContainer>
            </FlexContainer>
            <FlexContainer className="width100 flex-column gap-10">
              <Label
                className="fontGray400"
                type={isInlineStyle ? 'text-18' : 'text-20'}
              >
                <strong>{spaceInfo?.formattedPrice}</strong>
              </Label>
            </FlexContainer>
          </FlexContainer>
        )}
      </FlexContainer>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Detailed Space Info"
      >
        <div onClick={e => e.stopPropagation()}>
          <DetailedSpaceInfo spaceInfo={spaceInfo} closeModal={closeModal} />
        </div>
      </Modal>
    </FlexContainer>
  );
};

export default NewSpaceCardShortVersion;
